export default __webpack_public_path__ + "static/media/AAPG-Pivoting-4.5493506d.jpg";